module.exports = require("react-docgen");


//////////////////
// WEBPACK FOOTER
// external "react-docgen"
// module id = 88
// module chunks = 0